import React from 'react';
import { Row, Col, Glyphicon } from 'react-bootstrap';
import AuditRow from './AuditRow';
import { Button } from 'fw/components';
import * as API from 'modules/app/API';
import * as Help from 'modules/app/Help';

class AuditTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            title: "",
            filters: {},
            list: [],
            count: 0,
            rowCount: props.rowCount
        }
    }

    show = () => {

        // Set help 
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();

        // Initialize list 
        this.setState({
            list: []
        });

        this.search();
    }

    urls() {
        return {
            get: '/getObjectAudit'
        }
    }

    getEntityType() {
        return null;
    }

    getRequest(selectedId) {
        return {
            entity: this.props.entityType,
            key: selectedId,
            rowCount: this.state.rowCount,
            encryptedKey: this.props.encryptedKey
        }
    }

    search = () => {
        var rq = this.getRequest(this.props.selectedId);

        API.Audit.get(this.urls().get, rq,
            {
                success: (r) => {
                    this.setState({
                        list: r.data.items,
                        count: r.data.count
                    });
                }
            });
    }

    handleLoadMoreResults = () => {
        this.setState({
            rowCount: this.state.rowCount + this.props.rowCount
        }, function () {
            this.search()
        });
    }

    componentWillReceiveProps(nextProps) {
        // Only load when active        
        if (!nextProps.active)
            return;

        if (nextProps.active !== this.props.active) {
            this.show();
        }
    }

    componentDidMount() {
        if (!this.props.active)
            return;

        this.show();
    }

    render() {

        const listItems = this.state.list.map((item) =>
            <div key={item.auditId}>
                <div className="audit-row">
                    <AuditRow auditItem={item} />
                </div>
                <hr />
            </div>
        );

        return (
            <React.Fragment>
                <h2>{this.props.title}</h2>
                <hr />
                <Row>
                    <Col md={11}>
                        <div>
                            {this.state.list.length === 0 &&
                                <div>
                                    <p>There's not audit information yet.</p>
                                </div>
                            }
                            {this.state.list.length > 0 &&
                                <div>
                                    <Row>
                                        <Col md={12}>
                                            <div>{listItems}</div>
                                        </Col>
                                    </Row>
                                    <br />
                                    {this.state.count >= this.state.rowCount &&
                                        <Row>
                                            <Col md={12}>
                                                <Button id="btnViewMoreResults" className="pull-right" onClick={this.handleLoadMoreResults}>
                                                    <Glyphicon glyph="glyphicon glyphicon-repeat" style={{ marginRight: 10 }} />Show more results
                                                </Button>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            }
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

AuditTab.defaultProps = {
    rowCount: 20
};

export default AuditTab;



// WEBPACK FOOTER //
// ./src/areas/shared/components/audit/AuditTab.js